import Icon from '../components/Icon.vue'

Icon.register({"not-equal":{"width":448,"height":512,"paths":[{"d":"M416 208C433.7 208 448 193.7 448 176V144C448 126.3 433.7 112 416 112H392.1L444 45.2C449.4 38.2 448 28.1 441 22.8L415.6 3.3C408.6-2.1 398.6-0.7 393.2 6.3L311.1 112H32C14.3 112 0 126.3 0 144V176C0 193.7 14.3 208 32 208H236.6L162 304H32C14.3 304 0 318.3 0 336V368C0 385.7 14.3 400 32 400H87.5L35.6 466.8C30.3 473.8 31.6 483.9 38.6 489.2L64 508.7C71 514.1 81.1 512.7 86.4 505.7L168.5 400H416C433.7 400 448 385.7 448 368V336C448 318.3 433.7 304 416 304H243.1L317.6 208H416z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/not-equal.js
// module id = tIvr
// module chunks = 0